let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fqh3M")).then(() => parcelRequire('e8XZe'));